<template>
    <v-data-table
        :headers="headers"
        :items="entities"
        class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('src\\views\\triprequests\\list.2438') }}</v-toolbar-title>
                <v-spacer />
                <v-btn v-if="user.adminAccess && user.adminAccess.trip_requests >= ACCESS.WRITE" color="primary" @click="create">
                    <v-icon>mdi-plus</v-icon>{{ $t('src\\views\\triprequests\\list.5423') }}</v-btn>
            </v-toolbar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | moment('DD.MM.YYYY HH:mm') }}
        </template>
        <template v-slot:[`item.common`]="{ item }">
            {{ item.common ? 'Да' : 'Нет' }}
        </template>
        <template v-slot:[`item.blogger`]="{ item }">
            {{ item.blogger ? `${item.blogger.social} (${item.blogger.firstname} ${item.blogger.lastname})` : '-' }}
        </template>
        <template v-slot:[`item.trip`]="{ item }">
            {{ item.trip ? item.trip.name : '-' }}
        </template>
        <template v-slot:[`item.edit`]="{ item }">
            <v-icon color="primary" @click="edit(item._id)">mdi-pencil</v-icon>
        </template>
    </v-data-table>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';
    import { DIRECTION_TYPE_TITLE } from '../../vars';
    import { ACCESS } from '@/vars';

    export default {
        name: 'TripRequestsList',
        components: {
        },
        data: () => ({
            ACCESS,
            DIRECTION_TYPE_TITLE,
            headers: [],
        }),
        computed: {
            ...mapState('auth', ['user']),
            ...mapState('tripRequests', ['entities']),
        },
        async mounted() {
            await store.dispatch('auth/fetch');
            await store.dispatch('tripRequests/fetch', {});
            this.headers = [
                { text: this.$t('src\\views\\triprequests\\list.createdAt'), value: 'createdAt' },
                { text: this.$t('src\\views\\triprequests\\list.common'), value: 'common' },
                { text: this.$t('src\\views\\triprequests\\list.blogger'), value: 'blogger' },
                { text: this.$t('src\\views\\triprequests\\list.trip'), value: 'trip' },
            ];
            if(this.user && this.user.adminAccess && this.user.adminAccess.trip_requests >= ACCESS.WRITE) {
                this.headers.push({ text: '', align: 'right', value: 'edit' })
            }
        },
        methods: {
            async create() {
                await this.$router.push({ name: 'trip-requests-create' });
            },
            async edit(id) {
                await this.$router.push({ name: 'trip-requests-edit', params: { id } });
            }
        }
    }
</script>
